import {
  SelectQuestion,
  TextAreaQuestion,
  YesNoQuestion,
  DateQuestion,
} from "@common/components/shared/CustomerInteractionReview/Inputs";
import { mapToSelect } from "./forms";

const getFieldNameFromQuestion = (question) => {
  const { type, question: questionText, guid } = question;

  if (type.includes(":")) {
    const parts = type.split(":");
    if (parts.length > 1) {
      const fieldName = parts[1];
      if (fieldName === "venueEnterCount") return "venueEnterCountId";
      if (fieldName === "venueEnterTime") return "venueEnterTimeId";
      if (fieldName === "barCustomer") return "barCustomer";
      if (fieldName === "nextReview") return "nextReviewDate";
      return fieldName;
    }
  }

  const lowerText = questionText.toLowerCase();
  if (lowerText.includes("entered the venue")) return "enteredVenue";
  if (lowerText.includes("how many times")) return "venueEnterCountId";
  if (lowerText.includes("how long") && lowerText.includes("spend")) return "venueEnterTimeId";
  if (lowerText.includes("playing habits changed")) return "behaviourChanged";
  if (lowerText.includes("habits have changed") && lowerText.includes("explain")) return "behaviourComments";
  if (lowerText.includes("at risk of gambling harm") && !lowerText.includes("explain")) return "atRisk";
  if (lowerText.includes("measures") && lowerText.includes("reduce")) return "atRiskMeasures";
  if (lowerText.includes("another date") || lowerText.includes("escalated review")) return "anotherReview";
  if (lowerText.includes("date") && lowerText.length < 10) return "nextReviewDate";
  if (lowerText.includes("bar this customer")) return "barCustomer";

  return guid;
};

const getComponentFromType = (type) => {
  if (type.startsWith("bool")) return YesNoQuestion;
  if (type.startsWith("text")) return TextAreaQuestion;
  if (type.startsWith("date")) return DateQuestion;
  if (type.startsWith("lookup")) return SelectQuestion;
  return YesNoQuestion; // Default fallback
};

const getOptionsForQuestion = (type, metaData) => {
  if (type.includes("venueEnterCount")) {
    return mapToSelect(metaData.venueEnterCount || []);
  }
  if (type.includes("venueEnterTime")) {
    return mapToSelect(metaData.venueEnterTime || []);
  }
  return [];
};

export const transformReviewQuestions = (apiQuestions = [], metaData = {}, formValues = {}) => {
  if (!apiQuestions || apiQuestions.length === 0) {
    return [];
  }

  const guidToFieldName = {};
  apiQuestions.forEach((q) => {
    guidToFieldName[q.guid] = getFieldNameFromQuestion(q);
  });

  // Transform questions
  return apiQuestions
    .map((apiQuestion) => {
      const fieldName = getFieldNameFromQuestion(apiQuestion);
      const Component = getComponentFromType(apiQuestion.type);
      const options = getOptionsForQuestion(apiQuestion.type, metaData);

      let hidden = false;
      if (apiQuestion.parent && apiQuestion.condition !== null) {
        const parentFieldName = guidToFieldName[apiQuestion.parent];
        if (parentFieldName) {
          hidden = formValues[parentFieldName] !== apiQuestion.condition;
        }
      }

      const isPrimary = !apiQuestion.parent;

      return {
        name: fieldName,
        question: apiQuestion.question,
        Component,
        isPrimary,
        hidden,
        required: apiQuestion.required,
        guid: apiQuestion.guid,
        parentGuid: apiQuestion.parent,
        condition: apiQuestion.condition,
        ordinal: apiQuestion.ordinal,
        options: options.length > 0 ? options : undefined,
        fullWidth: apiQuestion.type.startsWith("text") || apiQuestion.type.startsWith("date"),
        hideLabel: apiQuestion.question === "Date" || apiQuestion.question.length < 5,
      };
    })
    .sort((a, b) => (a.ordinal || 0) - (b.ordinal || 0));
};
